/*global analytics, session, ga, ScarabQueue, config*/

const log = process.env.NODE_ENV === 'development' ? (...args) => console.log(...args) : () => {};

const TIMEOUT = 1500;

const tracker = {
  trackEvent(event, callback) {
    log('Track event', event);

    const ga_action = {
      hitType: 'event',
      eventCategory: event.category,
      eventAction: event.action,
    };
    if (typeof (event.label) !== 'undefined') {
      ga_action.eventLabel = event.label;
    }

    if (typeof (event.value) !== 'undefined') {
      ga_action.eventValue = event.value;
    }

    log('ga_action', ga_action);

    ga('send', ga_action);

    if (typeof (callback) !== 'undefined') {
      log('adding callback');
      ga(() => {
        setTimeout(callback, 5);
      });
    }
  },

  track(eventName, eventData, callback) {
    eventData.path = document.location.pathname;
    eventData.hostname = document.location.hostname;
    if (typeof eventData.layer === 'undefined') {
      eventData.layer = 'web';
    }

    let isCallbackCalled = false;

    setTimeout(() => {
      if (!isCallbackCalled) {
        if (callback) {
          callback();
        }
        isCallbackCalled = true;
      }
    }, TIMEOUT);

    tracker.ready(() => {
      analytics.track(eventName, eventData, () => {
        if (!isCallbackCalled) {
          if (callback) {
            callback();
          }
          isCallbackCalled = true;
        }
      });

      log('tracker#track', eventName, eventData);
    });
  },

  identify() {
    if (!session || !session.user) {
      log('session.user is not set in call to tracker#identify');
      return;
    }

    const id = session.user.id;
    const obj = {
      name: session.user.name,
      email: session.user.email,
    };

    tracker.ready(() => {
      analytics.identify(id, obj);
      ScarabQueue.push(['setCustomerId', config.NODE_ENV + '-' + id]);
      ScarabQueue.push(['go']);
      log('tracker#identify', id, obj);
    });
  },

  reset() {
    tracker.ready(() => {
      analytics.reset();
    });

    log('tracker#reset');
  },

  ready(callback) {
    let isCallbackCalled = false;

    setTimeout(() => {
      if (!isCallbackCalled) {
        if (callback) {
          callback();
        }
        isCallbackCalled = true;
      }
    }, TIMEOUT);

    analytics.ready(() => {
      if (!isCallbackCalled) {
        if (callback) {
          callback();
        }
        isCallbackCalled = true;
      }
    });

    log('tracker#ready');
  },
};

export default tracker;



// WEBPACK FOOTER //
// ./tracker.js